
import Card from '../base/Card';

export default function Team() {
  const team = [
    {
      name: 'Dra. Adriana Antunes Laginestra',
      role: 'Social Security Lawyer',
      oab: 'OAB 71.174/PR',
      image: 'https://static.readdy.ai/image/38b84c1503cd17b8f12bcbc9adbcc594/ee91d3affb124e810216bc0ad3545725.png',
      isPartner: false
    },
    {
      name: 'Dra. Jamile Sumaia Serea Kassem',
      role: 'Social Security Lawyer',
      oab: 'OAB 55.441',
      image: 'https://static.readdy.ai/image/38b84c1503cd17b8f12bcbc9adbcc594/d24782539c70fbaaa76fbc29429d934a.jpeg'
    },
    {
      name: 'Dra. Gabrielly Bergamaschi',
      role: 'Social Security Lawyer',
      oab: 'OAB 102.636',
      image: 'https://static.readdy.ai/image/38b84c1503cd17b8f12bcbc9adbcc594/850a2e724fcb6a01a40e421eba56bb2a.jpeg'
    },
    {
      name: 'Dr. Jonatan Altair Jerônimo Sossai',
      role: 'Social Security Lawyer',
      oab: 'OAB 98.431',
      image: 'https://static.readdy.ai/image/38b84c1503cd17b8f12bcbc9adbcc594/7e127d57d4b728d188abc026a2a32331.jpeg'
    },
    {
      name: 'Gustavo Henrique de Lima',
      role: 'Legal Advisor',
      oab: '',
      image: 'https://static.readdy.ai/image/38b84c1503cd17b8f12bcbc9adbcc594/3d8359120ee409253932450fe3e2dc23.png'
    }
  ];

  return (
    <section id="equipe" className="py-20 bg-black">
      <div className="container mx-auto px-4">
        <div className="text-center mb-16">
          <h2 className="text-3xl md:text-4xl font-serif font-bold text-white mb-4">
            Our Team
          </h2>
          <p className="text-xl text-gray-400 max-w-2xl mx-auto">
            Professionals specialized in Social Security Law
          </p>
        </div>

        <div className="grid md:grid-cols-2 lg:grid-cols-5 gap-8 max-w-7xl mx-auto">
          {team.map((member, index) => (
            <Card
              key={index}
              hover
              className="text-center"
            >
              <div className="relative mb-6">
                <img
                  src={member.image}
                  alt={member.name}
                  className="w-full h-64 object-cover object-top rounded-lg"
                />
              </div>

              <h3 className="text-lg font-semibold text-white mb-2">
                {member.name}
              </h3>

              <p className="text-[#b86846] font-medium mb-1">
                {member.role}
              </p>

              {member.oab && (
                <p className="text-gray-400 text-sm">
                  {member.oab}
                </p>
              )}
            </Card>
          ))}
        </div>
      </div>
    </section>
  );
}
